import http from 'utils/http';
import { PERMISSION_URL } from 'constants/endpoints';
import type { SingleResponse } from 'interface/service';

/**
 * Fetch all permissions.
 *
 * @returns {Array}
 */
export async function fetchAll<T = unknown>() {
  const { data } = await http.get<SingleResponse<T>>(PERMISSION_URL);

  return data;
}
